import {combineReducers} from 'redux';
import {reducer as reduxFormReducer} from 'redux-form';

import {type Action} from 'web-app/util/redux/action-types';
import importModalReducer from 'web-app/react/import/import-modal/reducer';
import famlyPayPaymentSetup from 'web-app/react/feed/post/embeds/payment-setup/reducer';
import groupHeader from 'web-app/react/institution/group-header/reducer';
import groupTagChart from 'web-app/react/institution/group-tag-chart/reducer';
import lists from 'web-app/react/lists/reducer';
import billingOverview from 'web-app/react/billing-overview/reducer';
import famlyLive from 'web-app/react/famly-live/reducer';
import lessonPlanSectionModal from 'web-app/react/lesson-plans/lesson-plan-section-modal/reducer';
import lessonPlans from 'web-app/react/lesson-plans/reducer';
import headCountModal from 'web-app/react/health-and-safeguarding/headcount/modal/reducer';
import parentalPermissionsMatrix from 'web-app/react/parental-permissions/matrix/reducer';
import pricingGroups from 'web-app/react/bookings-finance/hooks/redux-side-effects/pricing-groups/pricing-groups-reducer';

import accountSettings from '../account-settings/reducer';
import balances from '../balances/reducer';
import changeRoleModal from '../change-role-modal/reducer';
import childDevelopmentOverview from '../child-development/child-development-overview/reducer';
import asyncButton from '../components/async-link-button/reducer';
import billPayerForm from '../components/bill-payer-form/reducer';
import fileUpload from '../components/file-upload/reducer';
import documents from '../documents/reducer';
import entities from '../entities/reducer';
import famlyReport from '../famly-report/reducer';
import feed from '../feed/reducer';
import imageGallery from '../image-gallery/reducer';
import inbox from '../inbox/reducer';
import institutionSettings from '../institution/settings/reducer';
import mainNavigation from '../main-navigation/reducer';
import manageEmployeeRights from '../manage-employee-rights/reducer';
import meals from '../meals/reducer';
import modals from '../modals-container/reducer';
import notifications from '../notifications/reducer';
import organizationDashboard from '../organization/organization-overview/dashboard/reducer';
import organization from '../organization/reducer';
import parentalPermissions from '../parental-permissions/overview/reducer';
import invoiceSettings from '../plans/invoice-settings/reducer';
import plans from '../plans/reducer';
import billPayerProfileV2 from '../profile/bill-payer-v2/reducer';
import childProfile from '../profile/child-profile/reducer';
import employeeProfile from '../profile/employee-profile/reducer';
import session from '../session/reducer';
import topBar from '../top-bar/reducer';
import institutionPeople from '../institution-people/reducer';
import contract from '../routes/contract/reducer';
import activities from '../activities/reducer';
import quickSearch from '../quick-search/reducer';
import globalEvent from '../global-event/reducer';
import invoicingProfiles from '../invoicing-profiles/reducer';
import manageChildren from '../manage-children/reducer';
import inviteParents from '../invite-parents/reducer';
import abstractBudget from '../abstract-bugdet/reducer';
import login from '../login/reducer';
import cohortCompare from '../child-development/cohort-compare/reducer';
import advancedPermissions from '../manage-employees/permissions/reducer';
import customerSatisfaction from '../customer-satisfaction/reducer';
import twoFactorSettings from '../account-settings/two-factor-settings/reducer';
import leaveWidget from '../profile/leave-widget/reducer';
import manageOrganizationEmployees from '../organization/manage-employees/reducer';
import homePage from '../homepage/reducer';
import peoplePicker from '../people-picker/reducer';
import institutionOverview from '../institution/overview/reducer';
import newTag from '../institution/new-tag/reducer';
import importState from '../import/reducer';
import signInOut from '../settings/content/app-settings/sign-in-out/reducer';
import survey from '../routes/account/survey/reducer';
import confirmEmail from '../routes/confirm-email/reducer';
import dialog from '../dialog/reducer';
import navigationV2 from '../navigation-v2/reducer';
import {type RootState} from './root-state';

/*
 * This is a redux anti-pattern, however, we need to do this in order to listen for specific
 * actions inside of our Ember components.
 *
 * Store subscribers are not guaranteed to get all stage changes, so for lastAction we filter out non-Famly
 * actions in order to reduce the risk of missing an action.
 */
const lastAction = (state = {}, action: any) => (action.type.startsWith('@') ? state : action);
const anyLastAction = (state: RootState, action: any) => action || {};

// Please order additions alphabetically. Makes it a lot easier to navigate the state in redux dev tools
export const reducersObj = {
    abstractBudget,
    accountSettings,
    activities,
    advancedPermissions,
    anyLastAction,
    asyncButton,
    balances,
    billPayerForm,
    billPayerProfileV2,
    billingOverview,
    changeRoleModal,
    signInOut,
    childDevelopmentOverview,
    childProfile,
    cohortCompare,
    confirmEmail,
    contract,
    customerSatisfaction,
    dialog,
    documents,
    employeeProfile,
    entities,
    famlyLive,
    famlyPayPaymentSetup,
    famlyReport,
    feed,
    fileUpload,
    form: reduxFormReducer,
    globalEvent,
    groupHeader,
    groupTagChart,
    headCountModal,
    homePage,
    imageGallery,
    import: importState,
    importModal: importModalReducer,
    inbox,
    institutionOverview,
    institutionPeople,
    institutionSettings,
    inviteParents,
    invoiceSettings,
    invoicingProfiles,
    lastAction,
    leaveWidget,
    lessonPlanSectionModal,
    lessonPlans,
    lists,
    login,
    mainNavigation,
    manageChildren,
    manageEmployeeRights,
    manageOrganizationEmployees,
    meals,
    modals,
    navigationV2,
    newTag,
    notifications,
    organization,
    organizationDashboard,
    parentalPermissions,
    parentalPermissionsMatrix,
    peoplePicker,
    plans,
    pricingGroups,
    quickSearch,
    session,
    survey,
    topBar,
    twoFactorSettings,
};

export default combineReducers<RootState, Action<any>>(reducersObj);
